// VehicleSlice.ts
import { type PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import useFleetApi from '../data/fleetApi';
import { type Vehicle, VehicleMakerEnum, VehicleTypeEnum } from '../domain/vehicle';

const initialState: Vehicle = {
    color: '',
    height: 0,
    documentId: '-1',
    length: 0,
    licensePlate: '',
    maker: VehicleMakerEnum.alfa_romeo,
    model: '',
    weight: 0,
    width: 0,
    year: 0,
    vehicleType: { id: -1, name: '', typeRef: VehicleTypeEnum.break },
};

const vehicleSlice = createSlice({
    initialState,
    name: 'vehicle',
    reducers: {
        clearVehicle: () => initialState,
        setVehicle: (_, action: PayloadAction<Vehicle | null>) => action.payload ?? initialState,
    },
});

export const { setVehicle, clearVehicle } = vehicleSlice.actions;
export default vehicleSlice.reducer;

export const fetchVehicle = createAsyncThunk(
    'vehicle/fetchVehicle',
    async (vehicleId: number, { dispatch }) => {
        const { apiGetVehicle } = useFleetApi();
        const response = await apiGetVehicle(vehicleId);
        dispatch(setVehicle(response.data));
        return response.data;
    }
);

export const initializeVehicle = (vehicleId: number) => fetchVehicle(vehicleId);
